import React from 'react';

import { DateListControlProps } from './DateListControl.interfaces';
import { ListControl } from 'app/components/Controls';

export default function DateListControl(props: DateListControlProps) {
  return <ListControl {...props} cols={3} />;
}
